<template>
  <div id="camera_settings" class="custom-modal">
    <div v-if="devices.filter(k => k.kind == 'videoinput').length > 0">
      <video playsInline id="settings-video"></video>
    </div>

    <div
      id="settings-video"
      class="settings-video-no-device"
      v-else
    >
      <i
        class="fas fa-video-slash"
      ></i>
    </div>

    <div class="camera-settings-wrapper">
      <div v-if="errors.length" class="error">
        <p v-for="error in errors" :key="error.name">{{ error.message }}</p>
      </div>

      <div style="margin-bottom: 1rem;" v-if="errors.length > 0">
        <p style="margin-bottom:0px;">
          <a
            href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=tr"
            target="_blank"
            ><i class="fa fa-info-circle" style=" margin-right:5px;"></i>
            {{ $t("camera_settings.chrome_info") }}</a
          >
        </p>
        <p style="margin:0;">
          <a
            href="https://support.apple.com/tr-tr/guide/mac-help/mchlf6d108da/mac"
            target="_blank"
            ><i class="fa fa-info-circle" style="margin-right:5px;"></i>
            {{ $t("camera_settings.safari_info") }}</a
          >
        </p>
      </div>

      <div class="form-group">
        <label><strong>{{ $t("camera_settings.camera") }}: </strong></label>
        <div class="select_wrapper">
          <i class="fas fa-video"></i>
          <el-select v-model="videoDeviceId" placeholder="..." v-if="devices.filter(k => k.kind == 'videoinput').length > 0">
            <el-option
              v-for="device in devices.filter(k => k.kind == 'videoinput')"
              :key="device.deviceId"
              :label="device.label"
              :value="device.deviceId">
            </el-option>
          </el-select>
          <span v-if="devices.filter(k => k.kind == 'videoinput').length == 0" style="width:100%;">{{ $t("camera_settings.no_camera") }}</span>
        </div>
      </div>

      <div class="form-group">
        <label><strong>{{ $t("camera_settings.microphone") }}: </strong></label>
        <div class="select_wrapper">
          <i class="fas fa-microphone"></i>
          <el-select v-model="inputDeviceId" placeholder="..." v-if="devices.filter(k => k.kind == 'audioinput').length > 0">
            <el-option
              v-for="device in devices.filter(k => k.kind == 'audioinput')"
              :key="device.deviceId"
              :label="device.label"
              :value="device.deviceId">
            </el-option>
          </el-select>
          <span v-if="devices.filter(k => k.kind == 'audioinput').length == 0" style="width:100%;">{{ $t("camera_settings.no_microphone") }}</span>
        </div>
      </div>

      <canvas
        v-if="devices.filter(k => k.kind == 'audioinput').length > 0"
        id="setting_canvas"
        height="10"
      ></canvas>

      <div class="form-group">
        <label>
          <strong>{{ $t("camera_settings.speaker") }}: </strong>
          <a
              href="javascript:;"
              style="color: white; padding:10px;"
              @click="playSound"
            >
              <i :class="soundtest ? 'fa fa-pause' : 'fa fa-play'"></i>
            </a>
        </label>
        <div class="select_wrapper">
          <i class="fas fa-volume-up"></i>
          <el-select v-model="outputDeviceId" placeholder="..." v-if="devices.filter(k => k.kind == 'audiooutput').length > 0">
            <el-option
              v-for="device in devices.filter(k => k.kind == 'audiooutput')"
              :key="device.deviceId"
              :label="device.label"
              :value="device.deviceId">
            </el-option>
          </el-select>
          <span v-if="devices.filter(k => k.kind == 'audiooutput').length == 0" style="width:100%;">{{ $t("camera_settings.no_speaker") }}</span>
        </div>
      </div>

      <button
        class="btn-settings-ok"
        @click="startBroadCasting"
        v-if="errors.length == 0"
      >
        {{ $t("camera_settings.okey") }}
      </button>

      <button
        @click="refreshPage"
        v-if="errors.length > 0"
        style="border:none; z-index:9999999; float:left; width: 100%; height: 50px; display: flex; align-items: center; justify-content: center; font-size: 18px; color: white; border-radius: 3px; background: #288DA5; font-weight: bold; margin-top: 10px; cursor: pointer"
      >
        {{ $t("camera_settings.refresh_screen") }}
      </button>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "CameraSettings",
  props: ["roomType"],
  data() {
    return {
      enableWebcam: false,
      enableMic: false,
      soundtest: false,
      videoDeviceId: null,
      inputDeviceId: null,
      outputDeviceId: null,
      devices: [],
      javascriptNode: null,
      errors: []
    };
  },
  methods: {
    refreshPage() {
      window.location.reload(true);
    },
    startBroadCasting() {
      this.$store.state.settingsModal = false;
    },
    playSound() {
      if (!this.soundtest) {
        var sound = new Audio("/static/sound_test.mp3");
        sound.play();
      }

      this.soundtest = true;
      setTimeout(() => {
        this.soundtest = false;
      }, 500);
    }
  },
  async mounted() {
    var constraints = {
      video: true,
      audio: true
    };

    // Opera 8.0+
    var isOpera =
      (!!window.opr && !!opr.addons) ||
      !!window.opera ||
      navigator.userAgent.indexOf(" OPR/") >= 0;

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== "undefined";

    // Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && window["safari"].pushNotification)
      );

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    var isChrome =
      !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    var isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1;

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    switch (navigator.platform) {
      case "iPhone":
      case "iPod":
      case "iPad":
      case "iPhone Simulator":
      case "iPod Simulator":
      case "iPad Simulator":
      // case "Macintosh":
      // case "MacIntel":
      // case "MacPPC":
      // case "Mac68K":
      case "Pike v7.6 release 92":
      case "Pike v7.8 release 517":
        {
          // if(!isSafari)
          // {
          //   this.errors.push({
          //     name:'notSafari',
          //     message:'Apple ürünlerinden sorunsuz bir şekilde yayın yapabilmek için son sürüm safari kullanımı zorunludur.'
          //   })
          // }
        }
        break;
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function success(stream) {
        /* do stuff */
        stream.getTracks().forEach(function(track) {
          localStream.addTrack(track);
        });
      })
      .catch(err => {
        if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
          this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.notFound')
          });
        } else if (
          err.name == "NotReadableError" ||
          err.name == "TrackStartError"
        ) {
          this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.notReadable')
          });
        } else if (
          err.name == "OverconstrainedError" ||
          err.name == "ConstraintNotSatisfiedError"
        ) {
          this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.notFound')
          });
        } else if (
          err.name == "NotAllowedError" ||
          err.name == "PermissionDeniedError"
        ) {
          this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.notAllowed')
          });
           this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.openPermissions')
          });
        } else if (err.name == "TypeError" || err.name == "TypeError") {
          this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.notFound')
          });
        } else {
          this.errors.push({
            name: err.name,
            message: this.$t('deviceConnectionErrors.unexpectedProblem')
          });
        }
      });

    await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

    let devices = await navigator.mediaDevices.enumerateDevices();
    this.devices = devices;

    var videoDevices = this.devices.filter(k => k.kind == "videoinput");
    var microphoneDevices = this.devices.filter(k => k.kind == "audioinput");
    var outputDevices = this.devices.filter(k => k.kind == "audiooutput");

    if (videoDevices.length) {
      this.videoDeviceId = videoDevices[0].deviceId;

      setTimeout(() => {
        this.$emit("videoDeviceChanged", this.videoDeviceId);
      }, 4000);
    } else {
      this.errors.push({
        name: "-",
        message: this.$t('deviceConnectionErrors.noCameraFound')
      });
    }

    if (outputDevices.length) {
      var outputIndex = outputDevices.findIndex(
        x =>
          x.label
            .toString()
            .toLowerCase()
            .indexOf("speaker") != -1
      );
      if (window.innerWidth < 768 && outputIndex != -1) {
        this.outputDeviceId =
          outputDevices[
            outputDevices.findIndex(
              x =>
                x.label
                  .toString()
                  .toLowerCase()
                  .indexOf("speaker") != -1
            )
          ].deviceId;
      } else {
        this.outputDeviceId = outputDevices[0].deviceId;
      }

      setTimeout(() => {
        this.$emit("outputDeviceChanged", this.outputDeviceId);
      }, 4000);
    } else {
      // this.errors.push({
      //   name:"-",
      //   message: this.$t('deviceConnectionErrors.noOutputDevice')
      // });
    }

    if (microphoneDevices.length) {
      var inputIndex = microphoneDevices.findIndex(
        x =>
          x.label
            .toString()
            .toLowerCase()
            .indexOf("speaker") != -1
      );
      if (window.innerWidth < 768 && inputIndex != -1) {
        this.inputDeviceId =
          microphoneDevices[
            microphoneDevices.findIndex(
              x =>
                x.label
                  .toString()
                  .toLowerCase()
                  .indexOf("speaker") != -1
            )
          ].deviceId;
      } else {
        this.inputDeviceId = microphoneDevices[0].deviceId;
      }

      setTimeout(() => {
        this.$emit("inputDeviceChanged", this.inputDeviceId);
      }, 4000);
    } else {
      this.errors.push(
        this.$t('deviceConnectionErrors.noMicFound')
      );
    }
  },
  watch: {
    videoDeviceId: function() {
      this.$emit("videoDeviceChanged", this.videoDeviceId);
      navigator.mediaDevices
        .getUserMedia({ video: { deviceId: this.videoDeviceId } })
        .then(function(stream) {
          stream.getTracks().forEach(streamTrack => {
            localStream.addTrack(streamTrack);
          });
          var video = document.getElementById("settings-video");
          video.srcObject = stream;

          video.onloadedmetadata = function(e) {
            video.play();
          };
        })
        .catch(function(err) {
          console.log(err.name + ": " + err.message);
        });
    },
    outputDeviceId: function() {
      this.$emit("outputDeviceChanged", this.outputDeviceId);
    },
    inputDeviceId: function() {
      this.$emit("inputDeviceChanged", this.inputDeviceId);
      if (this.javascriptNode != null) {
        this.javascriptNode.disconnect();
      }
      navigator.mediaDevices
        .getUserMedia({ audio: { deviceId: this.inputDeviceId } })
        .then(stream => {
          stream.getTracks().forEach(streamTrack => {
            localStream.addTrack(streamTrack);
          });
          var audioContext = new AudioContext();
          var analyser = audioContext.createAnalyser();
          var microphone = audioContext.createMediaStreamSource(stream);
          this.javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

          analyser.smoothingTimeConstant = 0.1;
          analyser.fftSize = 1024;

          microphone.connect(analyser);
          analyser.connect(this.javascriptNode);
          this.javascriptNode.connect(audioContext.destination);

          var canvasContext = $("#setting_canvas")[0].getContext("2d");

          this.javascriptNode.onaudioprocess = function() {
            var array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            var values = 0;

            var length = array.length;
            for (var i = 0; i < length; i++) {
              values += array[i];
            }

            var average = values / length;
            canvasContext.clearRect(0, 0, 300, 300);
            canvasContext.fillStyle = "#ddd";
            canvasContext.fillRect(0, 0, 300 - average * 1.5, 10);
          };
        })
        .catch(function(err) {
          console.log(err.name + ": " + err.message);
        });
    }
  }
};
</script>



<style lang="less">



#camera_settings {
  display: flex;
  justify-content: space-around;
  word-break: break-word;

  .camera-settings-wrapper {
    padding: 0px 20px;
    .error {
      background: rgb(245, 14, 46);
      color: white;
      border-radius: 3px;
      padding: 10px 10px;
       p {
        margin-bottom:10px;
        word-break: break-word;
       }
    }
    .form-group {
      margin-bottom:10px;
    }
  }

  #setting_canvas {
    width: 100%;
    background: #55BCBC;
    transform: rotate(180deg);
    border-radius: 10px;
    margin-bottom:10px;
  }

  .btn-settings-ok {
    border:none;
    z-index:9999999;
    float:left;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: white;
    border-radius: 3px;
    background: #288DA5;
    font-weight: bold;
    margin-top: 10px; cursor: pointer;
  }
}



.settings-video-no-device {
   background:#f3f3f3;
  display:flex;
  justify-content:center;
  align-items:center;
  i {
    color:white !important;
    font-size:30px;
    transform: rotateY(-180deg);

  }
}

#settings-video {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 20px;
  background-color: #000;
  transform: rotateY(180deg);

  @media screen and (max-width: 767.98px) {
    margin: auto;
    width: calc(~"100% - 40px");
    margin-bottom: 20px;
  }
}


.select_wrapper {
  display: flex;
  align-items: center;

}

.select_wrapper i {
  margin-right:10px;
}

@media (max-width: 768px) {
  .settings-dialog-wrapper {
    .el-dialog {
      width: 90%;
      max-height: unset !important;
      overflow: auto !important;
    }

    #camera_settings {
      flex-direction: column;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/event/CameraSettings.vue